import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { FormFields } from '../../AccountForm.meta';

export const SelfEmployed = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Checkbox {...formBag.register('bankAccount.SelfEmployed')}>
      Self Employed Contribution
    </Checkbox>
  );
};
